import { createFeatureSelector, createSelector } from '@ngrx/store';
import { paginationFeatureKey, PaginationState } from './pagination.reducers';

export const selectPageSizeState = createFeatureSelector<PaginationState>(paginationFeatureKey);

export const selectPageSizeValues = createSelector(selectPageSizeState, (state): { selectedPageSize: number; previousPageSize: number } => ({
    selectedPageSize: state.pageSizeValue.selectedPageSize,
    previousPageSize: state.pageSizeValue.previousPageSize
}));
